// extracted by mini-css-extract-plugin
export default {"container":"register_container__qUUrl","description":"register_description__1XmWX","links":"register_links__aLJBy"};